namespace GeniuzPOS.Purchase {
    export class PoCNRTVColumns {
        static columnsKey = 'Purchase.PoCNRTV';
    }
}
